import moment from 'moment';
import I18n from '../locales/i18n';

const getPublishTime = (date) => {
	date = moment(date, 'YYYY-MM-DD HH:mm:ss Z');
	const now = moment(),
		diff = now.diff(date, 'minutes');

	let time = diff;

	if (diff < 4)
		return `${I18n('PUBLISH_TIME', 'HACE')} ${I18n(
			'PUBLISH_TIME',
			'ONE_MOMENT'
		)} ${I18n('PUBLISH_TIME', 'AGO')}`;
	if (diff < 60)
		return `${I18n('PUBLISH_TIME', 'HACE')} ${diff} ${I18n(
			'PUBLISH_TIME',
			'MINUTE'
		)}s ${I18n('PUBLISH_TIME', 'AGO')}`;
	time = Math.round(diff / 60);
	if (time < 24)
		return `${I18n('PUBLISH_TIME', 'HACE')} ${time} ${I18n(
			'PUBLISH_TIME',
			'HOUR'
		)}${time === 1 ? '' : 's'} ${I18n('PUBLISH_TIME', 'AGO')}`;
	time = Math.round(diff / (60 * 24));
	if (time < 30)
		return `${I18n('PUBLISH_TIME', 'HACE')} ${time} ${I18n(
			'PUBLISH_TIME',
			'DAY'
		)}${time === 1 ? '' : 's'} ${I18n('PUBLISH_TIME', 'AGO')}`;
	time = Math.round(diff / (60 * 24 * 30 * 12));
	if (time < 12)
		return `${I18n('PUBLISH_TIME', 'HACE')} ${time} ${I18n(
			'PUBLISH_TIME',
			'YEAR'
		)}${time === 1 ? '' : 's'} ${I18n('PUBLISH_TIME', 'AGO')}`;

	return date;
};

export default getPublishTime;
